import { AlertOctagon, AlertTriangle, Info, ShieldCheck } from 'lucide-react';

import { EstadoVazio } from '@/ui/components/estado-vazio';
import { Badge } from '@/ui/primitives/badge';
import { type ResultadoConferencia, type Severidade } from '@fiscoai/contracts';

import { SEVERIDADE } from './rotulos';

const ORDEM: Record<Severidade, number> = { ERRO: 0, ALERTA: 1, INFORMACAO: 2 };
const ICONE: Record<Severidade, typeof Info> = {
  ERRO: AlertOctagon,
  ALERTA: AlertTriangle,
  INFORMACAO: Info,
};
const COR: Record<Severidade, string> = {
  ERRO: 'text-perigo',
  ALERTA: 'text-alerta',
  INFORMACAO: 'text-info',
};

/** Conferências fixas que acusaram algo, da mais grave para a mais leve. */
export function AbaConferencias({
  conferencias,
}: {
  conferencias: readonly ResultadoConferencia[];
}) {
  if (conferencias.length === 0) {
    return (
      <EstadoVazio
        icone={<ShieldCheck />}
        titulo="Nenhuma conferência acusou problema"
        texto="Destinatário, totais, chave, CFOP e tributos conferem com as regras fixas."
      />
    );
  }
  const ordenadas = [...conferencias].sort((a, b) => ORDEM[a.severidade] - ORDEM[b.severidade]);
  return (
    <ul className="grid gap-2">
      {ordenadas.map((c) => {
        const Icone = ICONE[c.severidade];
        return (
          <li
            key={`${c.codigo}-${String(c.nItem ?? 0)}`}
            className="flex animate-surgir items-start gap-3 rounded-cartao border border-borda p-3"
          >
            <Icone className={`mt-0.5 size-4 shrink-0 ${COR[c.severidade]}`} aria-hidden />
            <div className="grid min-w-0 flex-1 gap-1">
              <span className="font-medium">{c.mensagem}</span>
              <span className="flex flex-wrap items-center gap-1.5 text-xs text-texto-fraco">
                <Badge tom={SEVERIDADE[c.severidade].tom}>{SEVERIDADE[c.severidade].rotulo}</Badge>
                <span className="font-mono">{c.codigo.slice(0, 3)}</span>
                {c.nItem !== null && <span>Item {c.nItem}</span>}
              </span>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
